import { ChangeDetectionStrategy, Component } from '@angular/core';
import { APP_VERSION } from '../../../../version.generated';

/**
 * Tiny glass pill that shows the current app version + short git SHA.
 * Reads from auto-generated version file (built from package.json + git sha).
 */
@Component({
  selector: 'om-version-pill',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[10px] font-medium tracking-wide
             bg-white/40 dark:bg-white/[0.06] backdrop-blur-md
             border border-white/30 dark:border-white/10
             text-slate-500/80 dark:text-slate-400/70
             shadow-[0_1px_2px_rgba(0,0,0,0.04)] dark:shadow-[0_1px_2px_rgba(0,0,0,0.2)]
             select-none"
      [title]="'Built ' + version.buildDate"
    >
      <span class="opacity-70">v</span>{{ version.version }}
      <span class="opacity-40">·</span>
      <span class="font-mono opacity-70">{{ version.gitSha }}</span>
    </span>
  `,
})
export class VersionPill {
  readonly version = APP_VERSION;
}
